import store from '@/store'
export default {
  methods: {
    setRingingVolume () {
      const volume = store.getters['settings/audioSettingsGetter'].ringingVolume
      const audioElements = [
        document.getElementById('ringing-audio'),
        document.getElementById('test-ringing-audio')
      ]
      audioElements.forEach(item => { item.volume = volume })
    },
    setCallerVolume () {
      const volume = store.getters['settings/audioSettingsGetter'].callerVolume
      const audioElements = [
        document.getElementById('caller-audio'),
        document.getElementById('test-caller-audio')
      ]
      audioElements.forEach(item => { item.volume = volume })
    }
  }
}
